import EmbedHtml from '@/components/embeds/EmbedHtml/EmbedHtml'
import styles from './StorylineGoogleMap.module.scss'

export default function StorylineGoogleMap({
  item,
}: {
  readonly item: {
    readonly model: {
      readonly fields: {
        readonly html: {
          readonly value: string
        }
      }
    }
  }
}) {
  return (
    <div className={styles.wrapper}>
      <EmbedHtml html={item.model.fields.html.value} />
    </div>
  )
}
